import axios from "../axiosPlugin.js";

export const createRuleTemplate = (data, loading = true) => {
  return axios({
    url: "/api/ticketRuleTemplate/create",
    method: 'post',
    data: {
      data,
      loading
    },
  })
};

export const getGroupList = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/group/list",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getTicketTypeList = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/ticketType/list",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getCouponTypeList = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/couponType/list",
    method: 'get',
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  })
}

export const getAdvanceCouponTypeList = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/advanceCouponType/list",
    method: 'get',
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  })
}

export const getRuleDetail = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/ticketRuleTemplate/detail/" + data.id,
    method: 'get',
    data: {
      data: {},
      loading,
      isDefaultAlertTips,
    },
  })
}

export const updateRule = (data, loading = true) => {
  return axios({
    url: "/api/ticketRuleTemplate/update",
    method: 'put',
    data: {
      data,
      loading
    },
  })
}

export const getCLCouponListService = (data, loading = true) => {
  return axios({
    url: `/api/cl/coupon/options-list`,
    method: 'get',
    data: {
      data,
      loading
    },
  })
}
